// import { query } from '../utils/url'
var ua = window.navigator.userAgent;
var androidAppREG = /didigsui.*_(.+)_\d+.*/ig;
var iosAppREG = /ddudriver.*_(\d+\.\d+\.\d+).*/ig;
var androidApp = androidAppREG.exec(ua) || '';
// const urlParams: any = query(window.location.href)
var iOSApp = iosAppREG.exec(ua) || '';
var isAndroidApp = !!androidApp;
var isIOSApp = !!iOSApp;
var isApp = isAndroidApp || isIOSApp || false;
var appVersion = androidApp[1] || iOSApp[1] || '';
var isHonghu = /mvpdriver/.test(ua);
// const isHk = /didigsui_driverhk.*_(.+)_\d+.*/i.test(ua) || /ddudriver_driverhk.*_(\d+\.\d+\.\d+).*/i.test(ua) || /357/.test(<string>urlParams.fcityid) || ((!urlParams.fcityid) && urlParams.lang === 'zh-HK')
export default {
    isApp: isApp,
    isIOSApp: isIOSApp,
    isAndroidApp: isAndroidApp,
    appVersion: appVersion,
    isHonghu: isHonghu
    // isHk
};
